import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Home.css';

const testimonials = [
  {
    text: "Analysis of Balance Report in a short period of time makes audit effective.",
    name: "Amit",
    location: "Mumbai",
    
  },
  {
    text: "Great work! A very effective tool for conducting bank audits properly on risk-based assessment.",
    name: "Ankur",
    location: "Bhilwara",
    
  },
  {
    text: "This software provides accurate insights and helps in decision-making.",
    name: "Rohit",
    location: "Delhi",
    
  },
  {
    text: "Excellent tool for financial data reconciliation, highly recommended!",
    name: "Sneha",
    location: "Pune",
    
  },
  {
    text: "User-friendly and highly efficient, made my work much easier.",
    name: "Kiran",
    location: "Bangalore",
    
  }
];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 2) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 2 + testimonials.length) % testimonials.length);
  };

  return (
<div >
      
      {/* Hero Section */}
<div className="hero-section">
  <video autoPlay loop muted playsInline className="hero-video">
    <source src="hero-video.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="home-content">
    <h1>Welcome to Data Bolta Hai</h1>
    <p>
      We provide hassle-free solutions, the most powerful and advanced GST 
      Reconciliation process for our clients to reduce the burden of GST compliance. 
      Our solutions are smart enough to auto-identify and match most of the entries 
      to ensure about 100% claim of ITC.
    </p>
    <button className="hero-button" onClick={() => document.getElementById('services-section').scrollIntoView({ behavior: 'smooth' })}>
  Explore
</button>
  </div>
</div>


      {/* About Us Section */}
       <div className="about-section">
        <div className="about-text">
          <h3>About Us</h3>
          <h2>Founded in 2003, by Relax Soft</h2>
           <p>
             At Data Bolta Hai, we have young and experienced energetic 
             professionals with a positive approach and a commitment to providing 
             the best solutions for GST reconciliation and compliance automation.
             Our approach is backed by advanced algorithms, analytical skills, 
             and IT tools to ensure error-free results, supporting better decision-making.
           </p>
           <button className="discover-button">Discover More</button>
         </div>
         <div className="about-image">
           <img src="/about.gif" alt="About Us Illustration" />
         </div>
       </div>

      {/* Our Services Section */}
<div id="services-section" className="services-section">
  <h2 className="section-title">Our Services</h2>
  <div className="services-grid">
    <div className="service-card">
      <span className="service-icon">📊</span>
      <h3 className="service-title">Big Data Solution</h3>
      <p className="service-description">
        Analyze, process, and extract insights from large datasets efficiently.
      </p>
      <a href="/big-data-solution" className="service-link">
        Learn More →
      </a>
    </div>
    <div className="service-card">
      <span className="service-icon">🏦</span>
      <h3 className="service-title">Bank Data Solution</h3>
      <p className="service-description">
        Ensure compliance, fraud detection, and financial insights for banking data.
      </p>
      <a href="/bank-data-solution" className="service-link">
        Learn More →
      </a>
    </div>
    <div className="service-card">
      <span className="service-icon">💰</span>
      <h3 className="service-title">GST Reconciliation</h3>
      <p className="service-description">
        Automate and streamline GST reconciliation for better compliance and accuracy.
      </p>
      <a href="/gst-reconciliation" className="service-link">
        Learn More →
      </a>
    </div>
    <div className="service-card">
      <span className="service-icon">🕵️‍♂️</span>
      <h3 className="service-title">Data Forensic</h3>
      <p className="service-description">
        Investigate and analyze digital evidence to detect fraud, cybercrimes, and security threats.
      </p>
      <a href="/cyber-forensic" className="service-link">
        Learn More →
      </a>
    </div>
    <div className="service-card">
      <span className="service-icon">📞</span>
      <h3 className="service-title">Call Analytics</h3>
      <p className="service-description">
        Gain insights from call data, monitor call performance, and enhance customer interactions.
      </p>
      <a href="/call-analytics" className="service-link">
        Learn More →
      </a>
    </div>
    <div className="service-card">
  <span className="service-icon">🛡️</span>
  <h3 className="service-title">Cyber Security</h3>
  <p className="service-description">
    Protect your digital assets with advanced security solutions, threat detection, and risk mitigation strategies.
  </p>
  <a href="/cyber-security" className="service-link">
    Learn More →
  </a>
</div>

<div className="service-card">
  <span className="service-icon">📢</span>
  <h3 className="service-title">Digital Marketing</h3>
  <p className="service-description">
  Transform your digital presence with innovative marketing strategies tailored for BFSI and other industries.  </p>
  <a href="/digital-market" className="service-link">
    Learn More →
  </a>
</div>

  </div>
</div>


       {/* Contact Section */}
      <div className="contact-section">
        <div className="contact-left">
          <img src="/home-contact.png" alt="Team Discussion" className="contact-image" />
        </div>
        <div className="contact-right">
          <div className="email-icon">
            <span>📧</span>
          </div>
          <h2>Are you looking for any data analytical tool?</h2>
          <Link to="/contact-us" className="contact-button" onClick={() => window.scrollTo(0, 0)}>
          Contact Now
          </Link>

        </div>
      </div>


      {/* Testimonial Section */}
      <div className="testimonial-section">
        <h2 className="section-title">Hear What Our Lovely Clients Say!</h2>
        <div className="testimonial-wrapper">
          <button className="arrow-button left" onClick={handlePrev}>
            <FaChevronLeft />
          </button>
          <div className="testimonial-container">
            {testimonials.slice(currentIndex, currentIndex + 3).map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <span className="quote-icon">❝</span>
                <p>{testimonial.text}</p>
                <div className="client-info">
                  {/* <img src={testimonial.image} alt={testimonial.name} className="client-img" /> */}
                  <h4>{testimonial.name} <span>({testimonial.location})</span></h4>
                </div>
              </div>
            ))}
          </div>
          <button className="arrow-button right" onClick={handleNext}>
            <FaChevronRight />
          </button>
        </div>
      </div>  
    </div>
  );
};

export default Home;
